import { createSlice, current } from '@reduxjs/toolkit';
import {
	getUtmZoneList,
	getUtmZoneListQuery,
	getUtmZone,
	addNewUtmZone,
	updateUtmZone,
	deleteUtmZone,
	checkUtmZoneExists,
} from './thunk';

export const initialState = {
	itemUtmZoneList: [],
	itemUtmZone: null,
	isUtmZoneLoading: false,
	isUtmZoneSuccess: false,
	dataUtmZone: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false,
};

const UtmZoneSlice = createSlice({
	name: 'UtmZone',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getUtmZoneList.pending, state => {
			state.isLoadingList = true;
			state.isUtmZoneSuccess = false;
		});

		builder.addCase(getUtmZoneList.fulfilled, (state, action) => {
			let statementList = action.payload;
			if (action.payload?.data) {
				statementList = action.payload.data;
			}
			state.itemUtmZoneList = Array.isArray(statementList) ? statementList : [];
			state.statementList = state.itemUtmZoneList;
			state.isLoadingList = false;
			state.isUtmZoneSuccess = true;
		});

		builder.addCase(getUtmZoneList.rejected, (state, action) => {
			state.isLoadingList = false;
			state.isUtmZoneSuccess = false;
			state.itemUtmZoneList = [];
		});

		builder.addCase(getUtmZoneListQuery.pending, state => {
			state.isLoadingList = true;
			state.isUtmZoneSuccess = false;
		});

		builder.addCase(getUtmZoneListQuery.fulfilled, (state, action) => {
			let statementList = action.payload;
			if (action.payload?.data) {
				statementList = action.payload.data;
			}
			state.itemUtmZoneList = Array.isArray(statementList) ? statementList : [];
			state.statementList = state.itemUtmZoneList;
			state.isLoadingList = false;
			state.isUtmZoneSuccess = true;
		});

		builder.addCase(getUtmZoneListQuery.rejected, (state, action) => {
			state.isLoadingList = false;
			state.isUtmZoneSuccess = false;
			state.itemUtmZoneList = [];
		});

		builder.addCase(getUtmZone.pending, state => {
			state.isLoadingList = true;
			state.isUtmZoneSuccess = false;
		});

		builder.addCase(getUtmZone.fulfilled, (state, action) => {
			state.itemUtmZone = action.payload;
			state.isLoadingList = false;
			state.isUtmZoneSuccess = true;
		});

		builder.addCase(getUtmZone.rejected, (state, action) => {
			state.isLoadingList = false;
			state.isUtmZoneSuccess = false;
		});

		builder.addCase(addNewUtmZone.pending, state => {
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewUtmZone.fulfilled, (state, action) => {
			let data = action.payload;
			if (action.payload?.data) {
				data = action.payload.data;
			}
			state.itemUtmZoneList = [data, ...current(state.itemUtmZoneList)];
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewUtmZone.rejected, (state, action) => {
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateUtmZone.pending, state => {
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateUtmZone.fulfilled, (state, action) => {
			let data = action.payload;
			if (action.payload?.data) {
				data = action.payload.data;
			}
			state.itemUtmZoneList = current(state.itemUtmZoneList).map(item =>
				item._id === data._id ? { ...item, ...data } : item
			);
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(updateUtmZone.rejected, (state, action) => {
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteUtmZone.pending, state => {
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteUtmZone.fulfilled, (state, action) => {
			let data = action.payload;
			if (action.payload?.data) {
				data = action.payload.data;
			}
			state.itemUtmZoneList = current(state.itemUtmZoneList).filter(
				item => item._id !== data._id
			);
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDeleteError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteUtmZone.rejected, (state, action) => {
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkUtmZoneExists.pending, state => {
			state.isLoadingList = true;
		});

		builder.addCase(checkUtmZoneExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
			state.isLoadingList = false;
		});

		builder.addCase(checkUtmZoneExists.rejected, (state, action) => {
			state.isLoadingList = false;
		});
	},
});

export const { setRequireCloseModal } = UtmZoneSlice.actions;

export default UtmZoneSlice.reducer;
